export const localPrefixUrl = "/api";

export const globalUrls = {
  config: "/config",
  faqs: "/faqs",
};

export const accountUrls = {
  account: "/account",
  shippingAccounts: "/account/shipping-accounts",
  dutiesTaxes: "/account/duties-taxes",
  carrierRegistrations: "/account/carrier-registrations",
};

export const onboardUrls = {
  sourceCountries: "/source-countries",
  states: "/get-states",
  destinationCountries: "/destination-countries",
  countries: "/get-countries",
  productCategories: "/product-categories",
  termsAndConditions: "/terms-conditions",
  companyDetails: "/company-details",
};
